import React, { useState } from 'react'
import './Pricing.scss'
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import { serviceCategories, pricingPlansByService } from './pricingData'
import PricingCard from './components/PricingCard'
import PricingTable from './components/PricingTable'
import Contect from '../Home/Components/Contect'

const Pricing = () => {
    const [selectedService, setSelectedService] = useState('support')
    const [expandedPlanId, setExpandedPlanId] = useState(null)

    const handleServiceClick = (serviceId) => {
        setSelectedService(serviceId)
    }

    const handleTogglePlan = (planId) => {
        setExpandedPlanId((prev) => (prev === planId ? null : planId))
    }

    const currentCategory = serviceCategories.find((c) => c.id === selectedService)
    const currentPlans = pricingPlansByService[selectedService] || pricingPlansByService.support
    const uiuxTableData = pricingPlansByService.uiux
    const videoServiceData = pricingPlansByService.video
    
    const headingLabel = selectedService === 'development'
        ? 'DEVELOPMENT PRICE'
        : selectedService === 'video'
            ? 'VIDEOS EDITING AND SOCIAL MEDIA'
            : currentCategory?.name
                ? `${currentCategory.name.toUpperCase()} PRICING`
                : 'PRICING'

    return (
        <div className="pricing_page">
            <Navigation offer={true} />

            <div className="pricing_content">
                <div className="container">
                    <div className="service_categories">
                        {serviceCategories.map((category) => (
                            <div
                                key={category.id}
                                className={`service_category_card ${selectedService === category.id ? 'active' : ''}`}
                                onClick={() => handleServiceClick(category.id)}
                                style={{ backgroundColor: selectedService === category.id ? category.color : '#FFFFFF' }}
                            >
                                <div className="service_icon"><img src={category.icon} alt={category.name} /></div>
                                <div className="service_name">{category.name}</div>
                            </div>
                        ))}
                    </div>

                   {selectedService === 'uiux' ? (
                        <PricingTable heading={uiuxTableData.heading} columns={uiuxTableData.columns} rows={uiuxTableData.rows} icons={uiuxTableData.icons} />
                   ) : selectedService === 'video' && videoServiceData ? (
                        <>
                            <PricingCard headingLabel={headingLabel} currentPlans={videoServiceData.cards} expandedPlanId={expandedPlanId} handleTogglePlan={handleTogglePlan} />
                            {videoServiceData.tables && videoServiceData.tables.map((table, index) => (
                                <PricingTable
                                    key={index}
                                    heading={table.heading}
                                    columns={table.columns}
                                    rows={table.rows}
                                    icons={table.icons}
                                    expandable={table.expandable}
                                    isAddOnsTable={table.isAddOnsTable}
                                />
                            ))}
                        </>
                   ) : (
                        <PricingCard headingLabel={headingLabel} currentPlans={currentPlans} expandedPlanId={expandedPlanId} handleTogglePlan={handleTogglePlan} />
                   )}
                </div>
            </div>
            <Contect/>
            <Footer />
        </div>
    )
}

export default Pricing
